import {languages} from "../constants/langConstants";

const contexts = require.context('.', true, /\.js$/);
const messages = {};

contexts.keys().forEach(fileName => {
  if (fileName === "./index.js") return;
  const lang = contexts(fileName).default;
  const dirName = fileName.split("/")[1];
  languages.forEach(function(value, index) {
    if(dirName.indexOf(value.locale)){
      if(messages[dirName] === undefined){
        messages[dirName] = {};
      }
      messages[dirName]['lang'] =  Object.assign({}, messages[dirName]['lang'], lang)
    }
  });
});

export default messages;